'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useEffect, useState } from 'react';
import { useSidebar } from '../index';

export function SidebarOverlay({
  isOpen,
  onMobileMenuClose,
}: {
  isOpen?: boolean;
  onMobileMenuClose?: () => void;
}) {
  const { toggleSidebar } = useSidebar();
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  // Listen for notifications popover content presence
  useEffect(() => {
    const handleNotificationsStateChange = () => {
      // Check if notifications popover content is present in the DOM
      // Use the specific data attribute we added to the notifications popover
      const notificationsPopover = document.querySelector(
        '[data-radix-popper-content-wrapper] [data-notifications-popover="true"]'
      );
      const isOpen = !!notificationsPopover;
      setNotificationsOpen(isOpen);
    };

    // Initial check
    handleNotificationsStateChange();

    // Set up observer to watch for popover content changes
    const observer = new MutationObserver((mutations) => {
      // Only process mutations that add/remove elements with our specific attribute
      const hasRelevantChanges = mutations.some((mutation) => {
        if (mutation.type !== 'childList') return false;

        // Check if any added/removed nodes contain our notifications popover
        const hasNotificationsPopover = (nodes: NodeList) => {
          return Array.from(nodes).some((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element;
              return (
                element.hasAttribute('data-notifications-popover') ||
                element.querySelector('[data-notifications-popover="true"]')
              );
            }
            return false;
          });
        };

        return (
          hasNotificationsPopover(mutation.addedNodes) ||
          hasNotificationsPopover(mutation.removedNodes)
        );
      });

      if (hasRelevantChanges) {
        handleNotificationsStateChange();
      }
    });

    // Observe only the document body for child list changes, not the entire subtree
    observer.observe(document.body, {
      childList: true,
      subtree: false, // Don't observe subtree to improve performance
    });

    return () => observer.disconnect();
  }, []);

  // Prevent body scrolling when notifications are open or mobile menu is open
  // Keep scrollbar visible to prevent layout shift
  useEffect(() => {
    const shouldPreventScroll = notificationsOpen || isOpen;

    if (shouldPreventScroll) {
      // Store current scroll position
      const scrollY = window.scrollY;

      // Prevent scrolling while keeping scrollbar visible
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflowY = 'scroll';
    } else {
      // Get the scroll position before we restore
      const scrollY = document.body.style.top;

      // Restore scrolling
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflowY = '';

      // Restore scroll position
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    }

    // Cleanup function to restore scrolling when component unmounts
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflowY = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    };
  }, [notificationsOpen, isOpen]);

  return (
    <div
      className="bg-grey-50/70 dark:bg-grey-1100/80 fixed inset-0 z-40 transition-opacity duration-200 ease-in-out data-[state=closed]:pointer-events-none data-[state=closed]:opacity-0 lg:hidden"
      data-state={isOpen ? 'open' : 'closed'}
      onClick={onMobileMenuClose || toggleSidebar}
    />
  );
}
